import React from 'react';
import classNames from 'classnames';
import { Icon } from '../Icon/Icon';
import styles from './InputCheckbox.module.scss';

interface InputCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
	className?: string;
	label?: string | React.ReactNode;
	id: string;
	checked: boolean;
	preselected?: boolean;
	variant?: 'default' | 'checkmark' | 'hidden';
}

/**
 * Generic InputCheckbox component, used for handling all checkbox type user input
 */
export const InputCheckbox: React.FunctionComponent<InputCheckboxProps> = ({
	className,
	id,
	label,
	checked,
	disabled,
	preselected,
	variant = 'default',
	onChange,
	...rest
}) => {
	const [isChecked, setIsChecked] = React.useState<boolean>(checked);

	const handleChange = (e): void => {
		setIsChecked(e.target.checked);

		if (onChange) {
			onChange(e);
		}
	};

	React.useEffect(() => {
		setIsChecked(checked);
	}, [checked]);

	return (
		<label
			className={classNames(
				styles.wrapperLabel,
				{ [styles.isDisabled]: disabled, [styles.isDisabledAndPreselected]: disabled && preselected },
				className,
			)}
			htmlFor={id}
		>
			<input
				className={classNames(styles.input, 'u-hide-visually')}
				type="checkbox"
				checked={isChecked}
				id={id}
				name={id}
				onChange={handleChange}
				{...rest}
			/>
			{variant === 'checkmark' ? (
				<Icon className={styles.checkMarker} name={'checkFilled'} size={'md'} />
			) : variant !== 'hidden' ? (
				<span className={styles.checkboxMarker} />
			) : null}
			{typeof label === 'string' ? <div>{label}</div> : <>{label}</>}
		</label>
	);
};
